<template>
  <vue-modal :key="refreshModal" :ref="modalName" :name="modalName" :scrollable="true" :width="700" :height="'auto'" @opened="openModal">
    <div class="modal-content roadmap-initiatives-reorder-modal">
      <div class="modal-header pb-0">
        <h5 class="modal-title">Reorder Initiatives<br/>
          <div v-if="sortedInitiatives.length > 0" class="reorder-initiative-focus-legend">* - Focus Area</div>
        </h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body roadmap-initiatives-reorder">
        <VueDraggable
          v-model="sortedInitiatives"
          :disabled="!enabled"
          class="list-group draggable-container w-100"
          ghost-class="draggable-ghost"
          @end="endOfDragInitiatives"
          options="people"
        >
          <div
            v-for="(initiative, index) in sortedInitiatives"
            :key="getInitiativeKey(initiative, index)"
            class="list-group-item draggable-card reorder-initiative-row"
          >
            <span class="reorder-initiative-need"><span class="pr-1" v-if="initiative.savedFocus">*</span>{{ initiative.name || initiative.needName }}</span>
          </div>
        </VueDraggable>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary mr-4" @click="saveOrder">Save</button>
        <button type="button" class="btn btn-primary" @click="closeModal">Close</button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import { VueDraggable } from 'vue-draggable-plus';

export default {
  name: "RoadmapInitiativesReorderModal",
  components: { VueDraggable },
  props: {
    modalName: {
      type: String,
      default: "roadmap-initiatives-reorder-modal"
    },
    initiatives: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      enabled: true,
      dragging: false,
      sortedInitiatives: [],
      hasOrderChanged: false,
      refreshModal: true
    };
  },
  methods: {
    openModal() {
      this.loadData();
    },
    loadData() {
      this.sortedInitiatives = JSON.parse(JSON.stringify(this.initiatives || []));
      this.hasOrderChanged = false;
    },
    getInitiativeKey(initiative, index) {
      if (!initiative) return index;
      return `${String(initiative.needType || "").toLowerCase()}:${initiative.needNumber || initiative.sequenceNumber || index}`;
    },
    endOfDragInitiatives(event) {
      let oldIndex = event.oldIndex;
      let newIndex = event.newIndex;
      this.dragging = false;
      if (oldIndex === newIndex) return;
      if (typeof this.sortedInitiatives[oldIndex] != "undefined" &&
          typeof this.sortedInitiatives[newIndex] != "undefined") {
        this.sortedInitiatives[newIndex].sequenceNumber = newIndex;
        this.sortedInitiatives[oldIndex].sequenceNumber = oldIndex;
        for (let index = 0; index < this.sortedInitiatives.length; index++) {
          this.sortedInitiatives[index].sequenceNumber = index;
        }
        this.hasOrderChanged = true;
      }
    },
    saveOrder() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;
      if (this.hasOrderChanged) {
        // reordering saving to parent
        this.$emit("reorder", this.sortedInitiatives);
      }
      this.closeModal();
      this.$nextTick(() => {
        window.requestAnimationFrame(() => window.scrollTo(scrollLeft, scrollTop));
      });
    },
    closeModal() {
      if (this.$refs[this.modalName] != null) {
        this.$refs[this.modalName].visible = false;
      }
      this.refreshModal = !this.refreshModal;
    }
  },
  watch: {
    initiatives: {
      handler() {
        this.loadData();
      },
      deep: true
    }
  },
};
</script>

<style scoped>
.reorder-initiative-row {
  align-items: flex-start;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: center;
  min-height: 30px;
  max-height: 30px;
  padding: 0.5rem 0;
  width: 50%;
}

.roadmap-initiatives-reorder-modal {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow: hidden;
}

.roadmap-initiatives-reorder {
  flex: 1 1 auto;
  overflow-y: auto;
}

.roadmap-initiatives-reorder .draggable-container {
  border: 0;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0;
  width: 100%;
}

.roadmap-initiatives-reorder .list-group-item {
  margin: 0 0 0.5rem 0;
  width: 50%;
}
.reorder-initiative-focus-legend {
  font-size: 0.9rem;
  margin-top: 0.2rem;
}
.reorder-initiative-need {
  flex: 1;
  text-align: center;
}
</style>
